import {
  Asn660,
  ControlTrailer,
  PlantRelease,
  ShippingNotice,
  TransactionSet,
  TransactionSetTrailer,
  TransactionSetTrailer2,
  Vehicle,
} from '../domain/asn660.model';
import {
  ASN660ApiModel,
  ControlTrailerApiModel,
  PlantRelease2ApiModel,
  PlantRelease3ApiModel,
  PlantReleaseApiModel,
  ShippingNotice2ApiModel,
  ShippingNotice3ApiModel,
  ShippingNoticeApiModel,
  TransactionSetApiModel,
  TransactionSetTrailer2ApiModel,
  TransactionSetTrailerApiModel,
  Vehicle2ApiModel,
  Vehicle3ApiModel,
  VehicleApiModel,
} from '../infrastructure/asn660-api.model';

export const mapAsn660 = (data: ASN660ApiModel): Asn660 => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    activityPlatformId: data.activityPlatformId,
    functionalGroupId: data.FunctionalGroupID,
    appsSenderCode: data.AppsSenderCode,
    appsReceiverCode: data.AppsReceiverCode,
    dataInterchageDate: data.DataInterchageDate,
    dataInterchangeTime: data.DataInterchangeTime,
    dataInterchangeControlNumber: data.DataInterchangeControlNumber,
    responsibleAgencyCode: data.ResponsibleAgencyCode,
    versionNumber: data.VersionNumber,
    transactionSets: data.TransactionSets.map(mapTransactionSet),
    transactionSetTrailers: data.TransactionSetTrailers.map(
      mapTransactionSetTrailer2
    ),
    controlTrailer: mapControlTrailer(data.ControlTrailer),
  };
};

export const mapAllAsn660s = (data: ASN660ApiModel[]): Asn660[] => {
  return data.map(mapAsn660);
};

export const mapTransactionSet = (
  data: TransactionSetApiModel
): TransactionSet => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    setIdentifier: data.SetIdentifier,
    transSetControlNumber: data.TransSetControlNumber,
    functionalGroupHeaderId: data.FunctionalGroupHeaderID,
    shippingNotice: mapShippingNotice(data.ShippingNotice),
    transactionSetTrailer: mapTransactionSetTrailer(data.TransactionSetTrailer),
  };
};

export const mapShippingNotice = (
  data:
    | ShippingNoticeApiModel
    | ShippingNotice2ApiModel
    | ShippingNotice3ApiModel
): ShippingNotice => {
  console.log(data.ediType);
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    scac: data.SCAC,
    productionStatus: data.ProductionStatus,
    splcOrigin: data.SPLCOrigin,
    splcDestination: data.SPLCDestination,
    specialServicesCode: data.SpecialServicesCode,
    dealerCode: data.DealerCode,
    ediType: data.ediType,
    transactionSetId: data.TransactionSetID,
    transactionSetTrailerId: data.TransactionSetTrailerID,
    log: data.log,
    isUsed: data.isUsed,
    isUsedDownload: data.isUsedDownload,
    vehicles: data.Vehicles.map(mapVehicle),
  };
};

export const mapVehicle = (
  data: VehicleApiModel | Vehicle2ApiModel | Vehicle3ApiModel
): Vehicle => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    vin: data.VIN,
    routeCodeOrigin: data.RouteCodeOrigin,
    routeCodeDestination: data.RouteCodeDestination,
    von: data.VON,
    dealerIdentificationNumber: data.DealerIdentificationNumber,
    storageStartDate: data.StorageStartDate,
    storageEndDate: data.StorageEndDate,
    dealerIdNumber: data.DealerIDNumber,
    vehicleUpdateDate: data.VehicleUpdateDate,
    vehicleUpdateTime: data.VehicleUpdateTime,
    shippingNoticeId: data.ShippingNoticeID,
    plantReleases: data?.PlantReleases?.map(mapPlantRelease),
  };
};

export const mapVehicles = (
  data: (VehicleApiModel | Vehicle2ApiModel | Vehicle3ApiModel)[]
): Vehicle[] => {
  return data.map(mapVehicle);
};

export const mapPlantRelease = (
  data: PlantReleaseApiModel | PlantRelease2ApiModel | PlantRelease3ApiModel
): PlantRelease => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    estimatedShipDate: data.EstimatedShipDate,
    expediteCode: data.ExpediteCode,
    merlCode: data.MerlCode,
    bodyModel: data.BodyModel,
    cityName: data.CityName,
    stateProvinceCode: data.StateProvinceCode,
    salesColorCode: data.SalesColorCode,
    cartaPorteHtsCode: data.CartaPorteHTSCode,
    referenceNumberQualifier: data.ReferenceNumberQualifier,
    referenceNumberSpecialAuth: data.ReferenceNumberSpecialAuth,
    weightUnitQualifier: data.WeightUnitQualifier,
    weight: data.Weight,
    heightUnitQualifier: data.HeightUnitQualifier,
    height: data.Height,
    lengthUnitQualifier: data.LengthUnitQualifier,
    length: data.Length,
    widthUnitQualifier: data.WidthUnitQualifier,
    width: data.Width,
    volumeUnitQualifier: data.VolumeUnitQualifier,
    volumeCubicFeet: data.VolumeCubicFeet,
    vehicleInformationId: data.VehicleInformationID,
  };
};

export const mapTransactionSetTrailer = (
  data: TransactionSetTrailerApiModel
): TransactionSetTrailer => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    numberIncludedSegments: data.NumberIncludedSegments,
    transactionSetControlNumber: data.TransactionSetControlNumber,
    functionalGroupHeaderId: data.FunctionalGroupHeaderID,
    shippingNotice: mapShippingNotice(data.ShippingNotice),
    transactionSetId: data.TransactionSetID,
  };
};

export const mapTransactionSetTrailer2 = (
  data: TransactionSetTrailer2ApiModel
): TransactionSetTrailer2 => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    numberIncludedSegments: data.NumberIncludedSegments,
    transactionSetControlNumber: data.TransactionSetControlNumber,
    functionalGroupHeaderId: data.FunctionalGroupHeaderID,
    shippingNotice: mapShippingNotice(data.ShippingNotice),
    transactionSetId: data.TransactionSetID,
  };
};

export const mapControlTrailer = (
  data: ControlTrailerApiModel
): ControlTrailer => {
  return {
    id: data.ID,
    createdAt: data.CreatedAt,
    updatedAt: data.UpdatedAt,
    deletedAt: data.DeletedAt,
    numberIncludedSets: data.NumberIncludedSets,
    dataInterchangeControlNumber: data.DataInterchangeControlNumber,
    functionalGroupHeaderId: data.FunctionalGroupHeaderID,
  };
};
